import React, { FunctionComponent } from 'react';

import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('error');

import { CaughtError } from './ErrorBoundary';

const getErrorString = (caughtError: CaughtError) => {
  const { error, info } = caughtError;

  return `Error: ${error.message || String(error)}.\nError info: ${
    info.componentStack
  }.`;
};

export const ErrorDetails: FunctionComponent<{ caughtError: CaughtError }> = ({
  caughtError,
}) => {
  return (
    <div>
      <h3>{format('more-details')}</h3>
      <pre
        style={{
          whiteSpace: 'pre-wrap',
          borderLeft: '2px solid red',
          paddingLeft: 20,
        }}
      >
        {getErrorString(caughtError)}
      </pre>
    </div>
  );
};
